import { useEffect, useState } from "react"
import { Button, Form } from "react-bootstrap"
import toast from "react-hot-toast"

import { useFetchClubsQuery, useUpdateClubDetailsMutation } from "../../app/clubsApiSlice"
import UpdateClubAddressInputs from "../../components/form-inputs/UpdateClubAddressInputs"
import LoadingTextSwap from "../../components/LoadingTextSwap"
import ControlInput from "../../components/form-inputs/UpdateControlInput"

const UpdateClubForm = ({ data, setEditMode }) => {
  const [updateClubDetails, { isLoading }] = useUpdateClubDetailsMutation()
  const { data: clubs } = useFetchClubsQuery()

  const { clubName, address, clubId } = data

  const [newClubName, setNewClubName] = useState(clubName)
  const [newAddress, setNewAddress] = useState(address)

  const [newAddressValid, setNewAddressValid] = useState(false)
  const [newClubNameValid, setNewClubNameValid] = useState(true)

  const [error, setError] = useState("")

  const allValid = newClubNameValid && newAddressValid

  const allFields = newClubName && newAddress.streetAddress && newAddress.city && newAddress.county && newAddress.postcode && newAddress.country

  useEffect(() => {
    if (error) {
      if (allFields && allValid) setError("")
      if (!allFields && error === "All fields must be valid") setError("All fields are required")
      if (!allValid && error === "All fields are required") setError("All fields must be valid")
    }
  }, [allValid, allFields])

  // Check if any fields have been edited
  const edited = [
    newClubName.trim() !== clubName,
    newAddress.streetAddress.trim() !== address.streetAddress,
    newAddress.city.trim() !== address.city,
    newAddress.county.trim() !== address.county,
    newAddress.postcode.trim() !== address.postcode,
    newAddress.country.trim() !== address.country,
  ].some(Boolean)

  const handleSave = async (e) => {
    e.preventDefault()

    const trimmedNewClubName = newClubName.trim()

    // Check if all fields are valid and display error messages
    if (isLoading) return
    if (!allFields) return setError("All fields are required")
    if (!newAddressValid) return setError("All fields must be valid")

    // Only update if something has changed, otherwise tell user "Update successful" and close the form
    try {
      if (edited) {
        if (trimmedNewClubName !== clubName) {
          // Check if club name is already in use
          if (Object.values(clubs).some(club => club.clubName === trimmedNewClubName)) {
            setClubNameError("Club name already in use")
            return
          }
        }

        await updateClubDetails({
          clubName: trimmedNewClubName,
          address: newAddress,
          clubId,
          nameChanged: newClubName !== clubName,
          members: data.members
        }).unwrap()
      }

      setEditMode(false)
      toast.success('Club details updated')
    } catch (error) {
      console.log(error)
      toast.error('Error updating club details')
    }
  }

  return (
    <Form onSubmit={handleSave}>
      <div>
        <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
          <b className="text-muted w-100 my-1">Club Name</b>
          <div className="w-100">
            <ControlInput
              isValid={newClubNameValid}
              setValid={setNewClubNameValid}
              setValue={setNewClubName}
              validTest={(value) => value.trim() !== ""}
              value={newClubName}
              type="text"
              name="club name"
            />
          </div>
        </div>
        <UpdateClubAddressInputs address={newAddress} setAddressValid={setNewAddressValid} setNewAddress={setNewAddress} />
      </div>
      {error && <p className="text-danger i text-center fw-semibold mt-2">{error}</p>}
      <Button
      disabled={isLoading}
        className="px-5 rounded-3 mt-3 mx-auto d-block"
        variant="dark"
        type="submit"
      >
        <LoadingTextSwap isLoading={isLoading}>
          Save
        </LoadingTextSwap>
      </Button>
    </Form>
  )
}

export default UpdateClubForm